import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Friend, go offline",
  "description": "",
  "published": "2019-07-12T00:00:00.000Z",
  "redirect_from": ["/blog/friend-go-offline/swizec/9151"],
  "categories": "Opinions, Personal, Travel + Events",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Hello friend,`}</p>
    <p>{`I've got a short message for you today: Go offline for a few days. Just try it. Trust me.`}</p>
    <p>{`It's the most wonderful experience. You won't get bored. Promise.`}</p>
    <lite-youtube {...{
      "videoid": "PeKKhviJr8M",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Me and The Girl tried it last weekend for our 5th anniversary. Go camping for 4 days into El Dorado where the LTE has zero bars.`}</p>
    <p>{`It was wonderful. It really was.`}</p>
    <p>{`Something magical happens when your LTE has zero bars. You immediately don't miss them. It's not like sitting in a restaurant when all your friends go to the restroom and your phone flies out your pocket right away. Or standing in line. Or even sometimes when peeing.`}</p>
    <p>{`Yes I check my phone at the urinal. It's bad.`}</p>
    <p>{`No bars? No problem. Don't even care.`}</p>
    <p>{`Yes we did miss Google Maps, tourist information, stuff like that. Asking real local human people for help was fun though. It wasn't as accurate as The Goog, oh no, it was `}<em parentName="p">{`better`}</em>{`. More real somehow.`}</p>
    <p>{`Seeing people walk around town without looking at their phone 80% of the time like they do in San Francisco was lovely too.`}</p>
    <p>{`So if the internet is so easy to ignore when you can't have it, why is it so difficult when you can?`}</p>
    <p>{`I think it's like junk food.`}</p>
    <p>{`It's a `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Supernormal_stimulus"
      }}>{`supernormal stimulus`}</a>{`. You take a bite and it overwhelms your senses. You love it to the core of your being. Ticks off all your instinctual boxes for `}<em parentName="p">{`"OMG THIS IS THE BEST THING EVER"`}</em></p>
    <p>{`You immediately want more.`}</p>
    <p>{`Like a peanut butter cup The Girl gave me a bite of in the car.`}</p>
    <p><em parentName="p">{`"Ew, I don't even like that."`}</em></p>
    <p>{`chew chew chew`}</p>
    <p>{`Damn I want another bite.`}</p>
    <p>{`You don't even like it that much yet you immediately want more because it's engineered to make you want more.`}</p>
    <p>{`And that's quite insidious.`}</p>
    <p>{`But it isn't even the worst part. The worst part is that news, social media, internet, all the things – they don't tell you `}<em parentName="p">{`what`}</em>{` to think, they tell you what to think `}<em parentName="p">{`about`}</em>{`.`}</p>
    <p>{`That part sucks.`}</p>
    <p>{`One of the hardest parts of modern life is keeping your mind your own. Have `}<em parentName="p">{`your`}</em>{` thoughts. Think about `}<em parentName="p">{`your`}</em>{` things. Be mindful about what you feed your mind with.`}</p>
    <p>{`It's hard. But offline it's easy. Easier than I thought.`}</p>
    <p>{`Having my own mind back for 4 days was wonderful. You have to try it.`}</p>
    <p>{`But how do you keep it up? 🤨`}</p>
    <p>{`I'm trying something new, perhaps you'd like to join me, no internet Saturdays. An idea swiped from Tim Ferris to be honest. He suggests no electronics Saturdays.`}</p>
    <p>{`That's too hardcore for me. My version goes like this:`}</p>
    <p>{`No internet consumption on Saturdays. You can play video games, you can read books, you can go for a walk, you can hang with friends, you can use your phone and computer to look stuff up. But no social media, no mindless swiping, none of that stuff.`}</p>
    <p>{`We'll see how it goes. It's a bit like putting a needle in the hands of a heroin addict and saying `}<em parentName="p">{`"You can hold this, but don't use it okay?"`}</em></p>
    <p>{`Happy Friday, you're the best ❤️`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      